// Special assets needed by the login page

import '../setup/jquery_setup'
import instUIFlashSetup from "setup/instui_flash_setup"

instUIFlashSetup()
